import { render, staticRenderFns } from "./CompanyOdcTable.vue?vue&type=template&id=2110545c"
import script from "./CompanyOdcTable.vue?vue&type=script&lang=js"
export * from "./CompanyOdcTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports